// Datas no calendário local do navegador, no formato YYYY-MM-DD usado pelos
// inputs de data. Não use toISOString aqui: ele converte para UTC e, perto da
// meia-noite, devolve o dia anterior ou o seguinte.

const doisDigitos = (valor) => String(valor).padStart(2, "0");

export const formatarDataLocalISO = (data) => {
  const ano = data.getFullYear();
  const mes = doisDigitos(data.getMonth() + 1);
  const dia = doisDigitos(data.getDate());

  return `${ano}-${mes}-${dia}`;
};

export const obterHojeLocalISO = (agora = new Date()) => {
  return formatarDataLocalISO(agora);
};

export const obterUltimoDiaDoMesLocalISO = (agora = new Date()) => {
  const ultimoDia = new Date(agora.getFullYear(), agora.getMonth() + 1, 0);

  return formatarDataLocalISO(ultimoDia);
};

// Datas YYYY-MM-DD podem ser comparadas como texto.
export const periodoEstaInvertido = (dataDe, dataAte) => {
  return Boolean(dataDe && dataAte && dataDe > dataAte);
};
